jQuery(document).ready(function($){

    $(".mCustomScrollbar").mCustomScrollbar({
        theme:"3d-dark",
        scrollButtons:{
            enable:true
        }
    });
    $('.sidebar_cat_box').each(function () {
        $('.sidebar_cat_box_header_toggleable', this).click(function () {
            $(this).toggleClass('isHidden');
            $(this).parent().find('.sidebar_cat_box_content').slideToggle();
        });
    });
});